import { Page } from "@shopify/polaris";
import React from "react";
import styled from "styled-components";
import { ExportFilesPolaris } from "../../components/admin/manager-files/ExportFilesPolaris";
import { getPathFromRouter } from "../../helper";

const Container = styled.div`
    margin: -1rem;
    @media (min-width: 640px) {
        margin: -1.5rem;
    }
`;

export const ExportFilesPagePolaris = (...props) => {
    const path = React.useMemo(() => {
        return getPathFromRouter(props);
    }, [props]);

    return (
        <Container>
            <Page title="Export Files" fullWidth>
                <ExportFilesPolaris path={path} />
            </Page>
        </Container>
    );
};
